import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from '@chakra-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import type { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import type { FieldPathFn } from '@ui/components/form';
import { get, useFormContext } from 'react-hook-form';

export function ProductComplexityForm({
  fieldPath,
}: {
  fieldPath: FieldPathFn<SnapSiteConfigEditFormDataUnvalidated>;
}) {
  const form = useFormContext<SnapSiteConfigEditFormDataUnvalidated>();

  const simpleFieldPath = fieldPath('simple');
  const moderateFieldPath = fieldPath('moderate');
  const complexFieldPath = fieldPath('complex');

  return (
    <Flex as="fieldset" direction={{ base: 'column', md: 'row' }} gap={2}>
      <FormControl
        isInvalid={!!get(form.formState.errors, simpleFieldPath)}
        isRequired
      >
        <FormLabel htmlFor={simpleFieldPath}>Simple:</FormLabel>

        <Input
          {...form.register(simpleFieldPath)}
          id={simpleFieldPath}
          type="number"
          inputMode="decimal"
          placeholder="Simple"
          step="0.01"
        />

        <ErrorMessage
          name={simpleFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>

      <FormControl
        isInvalid={!!get(form.formState.errors, moderateFieldPath)}
        isRequired
      >
        <FormLabel htmlFor={moderateFieldPath}>Moderate:</FormLabel>

        <Input
          {...form.register(moderateFieldPath)}
          id={moderateFieldPath}
          type="number"
          inputMode="decimal"
          placeholder="Moderate"
          step="0.01"
        />

        <ErrorMessage
          name={moderateFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>

      <FormControl
        isInvalid={!!get(form.formState.errors, complexFieldPath)}
        isRequired
      >
        <FormLabel htmlFor={complexFieldPath}>Complex:</FormLabel>

        <Input
          {...form.register(complexFieldPath)}
          id={complexFieldPath}
          type="number"
          inputMode="decimal"
          placeholder="Complex"
          step="0.01"
        />

        <ErrorMessage
          name={complexFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>
    </Flex>
  );
}
